import { useCallback, useEffect, useState } from "react";
import { getSerializedPack as getSerializedPackWithArgs } from "../Lib";
import { WebRTCTransfer } from "../systems/WebRTCTransfer";
import { Pack, PackAttachment } from "../Types";

type NetworkConnectorProps = {
  networkState: "idle" | "connecting" | "connected";
};

const getCode = async (overwriteCache: boolean = false) => {
  const existingCode = localStorage.getItem("CONNECT_CODE");
  if (!overwriteCache && existingCode) {
    return existingCode;
  }
  const response = await fetch("https://api.optimem.org/transfer/new").then(
    (res) => res.json(),
  );
  localStorage.setItem("CONNECT_CODE", response.id);
  return response.id;
};

export const NetworkConnector = (props: NetworkConnectorProps) => {
  const { networkState } = props;

  const [code, setCode] = useState("");

  const connect = () => {
    const connectCode = (document.getElementById(
      "connect-code",
    )! as HTMLInputElement)!.value.toLowerCase();
    console.log(connectCode);
    WebRTCTransfer.connect(connectCode);
  };

  useEffect(() => {
    (async () => {
      if (!code) {
        WebRTCTransfer.stopHost();
        let c = await getCode();
        setCode(c);
        WebRTCTransfer.host(c);
      }
    })();
  }, []);

  const onKeyDown = useCallback((e) => {
    if (e.key === "Enter") {
      connect();
    }
  }, []);

  const onClick = useCallback((e: any) => {
    // get connect code from input
    connect();
  }, []);

  return (
    <div
      style={{
        position: "absolute",
        right: 8,
        float: "right",
        alignItems: "center",
        display: "flex",
        justifyContent: "flex-end",
        alignSelf: "center",
        flexDirection: "row",
        // backgroundColor: "white",
      }}
    >
      <div id="status-text" style={{ paddingRight: 16, opacity: 0.5 }}></div>
      <div style={{ flexDirection: "column" }}>
        <div
          style={{ opacity: 0.6, fontSize: "0.8em", fontWeight: "bold" }}
        >
          CONNECT CODE
        </div>
        <strong
          style={{
            fontSize: "2em",
            fontFamily: "monospace",
            alignContent: "center",
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
          }}
          className="hoverable"
        >
          {code.toUpperCase() || "------"}{" "}
          <span
            className="tiny"
            onClick={async () => {
              WebRTCTransfer.stopHost();
              const code = await getCode(true);
              setCode(code);
              WebRTCTransfer.host(code);
            }}
            style={{
              fontSize: "0.5em",
              opacity: 0.5,
              marginLeft: 4,
              cursor: "pointer",
            }}
          >
            🔄
          </span>
        </strong>
      </div>
    </div>
  );
};
